/** Drive Memory global interactions. Works with Shopify section editor re-renders. */
(() => {
  'use strict';
  const txt = window.DM?.i18n || {};

  function initHeader() {
    const toggle = document.getElementById('mobile-menu-toggle');
    const menu = document.getElementById('mobile-menu');
    if (!toggle || !menu || toggle.dataset.dmReady) return;
    toggle.dataset.dmReady = 'true';

    function closeMenu(restoreFocus = false) {
      if (menu.hidden) return;
      menu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', txt.open_menu || 'Open menu');
      if (restoreFocus) toggle.focus();
    }
    toggle.addEventListener('click', () => {
      if (!menu.hidden) return closeMenu();
      menu.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', txt.close_menu || 'Close menu');
      menu.querySelector('a')?.focus();
    });
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => closeMenu()));
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') closeMenu(true);
    });
    document.addEventListener('click', event => {
      if (!menu.hidden && !event.target.closest('.nav-wrap')) closeMenu();
    });
    window.addEventListener('resize', () => {
      if (window.innerWidth > 1250) closeMenu();
    });
  }

  function initLocales() {
    document.querySelectorAll('[data-dm-locale-select]').forEach(select => {
      if (select.dataset.dmReady) return;
      select.dataset.dmReady = 'true';
      select.addEventListener('change', () => select.form?.submit());
    });
  }

  function initVehicleFinder() {
    const brand = document.getElementById('brandSelect');
    const model = document.getElementById('modelSelect');
    if (!brand || !model || brand.dataset.dmReady) return;
    brand.dataset.dmReady = 'true';

    const modal = document.getElementById('carModal');
    const modalBrand = document.getElementById('modalBrandSelect');
    const modalModel = document.getElementById('modalModelSelect');
    const modalClose = document.getElementById('carModalClose');
    let catalog = null;
    let restoreFocus = null;

    const makeOption = (name, value) => new Option(name, value);
    function fillModels(brandSelect, modelSelect) {
      modelSelect.replaceChildren(makeOption(txt.select_model || 'Select your model', ''));
      for (const vehicle of catalog?.brands?.[brandSelect.value] || []) {
        modelSelect.add(makeOption(vehicle.label, vehicle.handle));
      }
    }
    function fillBrands(brandSelect, modelSelect) {
      brandSelect.replaceChildren(makeOption(txt.select_brand || 'Select your make', ''));
      Object.keys(catalog?.brands || {}).sort((a,b) => a.localeCompare(b, document.documentElement.lang || 'en'))
        .forEach(name => brandSelect.add(makeOption(name, name)));
      fillModels(brandSelect, modelSelect);
    }
    function visitProduct(modelSelect) {
      if (!modelSelect.value) return modelSelect.focus();
      const root = (window.DM?.root || '/').replace(/\/?$/, '/');
      location.assign(`${root}products/${encodeURIComponent(modelSelect.value)}`);
    }
    function showModal(opener) {
      if (!modal || !modalBrand || !modalModel || !catalog) return;
      restoreFocus = opener || document.activeElement;
      fillBrands(modalBrand, modalModel);
      modalBrand.value = brand.value;
      fillModels(modalBrand, modalModel);
      modalModel.value = model.value;
      modal.classList.add('show');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-open');
      modalBrand.focus();
    }
    function hideModal() {
      if (!modal?.classList.contains('show')) return;
      modal.classList.remove('show');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('modal-open');
      restoreFocus?.focus();
    }

    brand.addEventListener('change', () => fillModels(brand,model));
    modalBrand?.addEventListener('change', () => fillModels(modalBrand,modalModel));
    document.getElementById('findButton')?.addEventListener('click', () => visitProduct(model));
    document.getElementById('modalFindButton')?.addEventListener('click', () => visitProduct(modalModel));
    modalClose?.addEventListener('click', hideModal);
    modal?.addEventListener('click', event => { if (event.target === modal) hideModal(); });
    document.addEventListener('keydown', event => {
      if (!modal?.classList.contains('show')) return;
      if (event.key === 'Escape') return hideModal();
      if (event.key !== 'Tab') return;
      const focusable = [...modal.querySelectorAll('button:not([disabled]), select:not([disabled]), a[href]')];
      if (!focusable.length) return;
      const first=focusable[0], last=focusable[focusable.length-1];
      if (event.shiftKey && document.activeElement === first) {event.preventDefault();last.focus();}
      else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first.focus();}
    });
    // Both the header CTA and bottom CTA can open the finder modal.
    document.querySelectorAll('a[href="#selector"]').forEach(link => {
      if (link.dataset.dmFinderReady) return;
      link.dataset.dmFinderReady = 'true';
      link.addEventListener('click', event => {event.preventDefault();showModal(link);});
    });
    // Finder selects the real vehicle product; the former static message is no longer needed.
    document.getElementById('resultPanel')?.remove();
    fetch(window.DM?.vehicleCatalogUrl || '', {cache:'force-cache'})
      .then(response => {if (!response.ok) throw new Error(`Vehicle catalog HTTP ${response.status}`);return response.json();})
      .then(data => {catalog=data;fillBrands(brand,model);})
      .catch(error => {
        console.warn('Drive Memory vehicle list unavailable:',error);
        brand.replaceChildren(makeOption(txt.load_error || 'Unable to load vehicles', ''));
        model.replaceChildren(makeOption(txt.retry || 'Please try again', ''));
      });
  }
  function init() {initHeader();initLocales();initVehicleFinder();}
  init();
  document.addEventListener('shopify:section:load', init);
})();
